import React from "react";
import {HeroImageSection} from "../components/common/HeroImageSection";
import {MembershipSection} from "../features/membership/components/MembershipSection";

const MembershipPage: React.FC = () => {

    return (
        <div className="bg-dark-mode text-ivory">
            <HeroImageSection
                image="/images/club_card.jpg"
                text="Membership"
                subtitle="Membership Tenure of 25 Years"
                nextSectionId="individual-membership-section"
            />
            <MembershipSection
                id="individual-membership-section"
                title="INDIVIDUAL MEMBERSHIP"
                description="A CATEGORY FOR ELIGIBLE INDIVIDUALS ALONG WITH SPOUSE AND UPTO 3 UNMARRIED CHILDREN BELOW THE AGE OF 25 YEARS"
                image='/images/membership_1.jpg'
            />
            <MembershipSection
                id="corporate-membership-section"
                title="CORPORATE MEMBERSHIP"
                description="A CATEGORY FOR CORPORATE BODY ONLY"
                image='/images/membership_2.webp'
                isDark={true} isLeftAligned={false}
            />
            <MembershipSection
                id="expatriate-membership-section"
                title="EXPATRIATE MEMBERSHIP"
                description="A CATEGORY RESERVED FOR FOREIGN NATIONALS WHO ARE TEMPORARILY RESIDING IN INDIA"
                image='/images/membership_3.webp'
            />
        </div>
    );
};

export default MembershipPage;